import { CartConfig } from '@spartacus/cart/base/root';

export const CUSTOM_CART_CONFIG: CartConfig = {
    cart: {
        validation: {
            enabled: true,
        },
    },
};
